//import React from "react"
//import Field from "../Field"

const Any = ({ domRef, info, value, children, ...props }) => {
    if (!value) return null
    if (children) return children
    return null
}
export default Any
